import { render } from "./signUp.vue?vue&type=template&id=0f64eeee"
import script from "./signUp.vue?vue&type=script&lang=js"
export * from "./signUp.vue?vue&type=script&lang=js"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BeeNeeGit\\CompStoreFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__